@for (item of notification.notifications$|async; track item.title; let i = $index) {
  <div>
    <app-notification [item]='item' [id]='i' (closeNotification)='notification.close(i)'
                      [@enterLeave]='item.state'></app-notification>
  </div>
}
